module.exports = new __parcel__URL__("close-button.0c1916bf.png").toString();